import {
  EmailUnsupportedReason,
  type EmailUnsupportedReason as EmailUnsupportedReasonValue,
} from '@/lib/api';

export function unsupportedEmailReasonMessage(
  reason: EmailUnsupportedReasonValue | undefined
): string {
  switch (reason) {
    case EmailUnsupportedReason.Empty:
      return 'Enter an email address.';
    case EmailUnsupportedReason.MultipleAddresses:
      return 'Enter exactly one email address.';
    case EmailUnsupportedReason.DisplayNameOrAngleAddress:
      return 'Use only the email address itself, without a display name or angle brackets.';
    case EmailUnsupportedReason.CommentsOrCfws:
      return 'Comments or extra address formatting are not supported.';
    case EmailUnsupportedReason.QuotedLocalPart:
      return 'Quoted local parts are not supported.';
    case EmailUnsupportedReason.NonAscii:
      return 'Use only ASCII characters in this email address.';
    case EmailUnsupportedReason.InternalWhitespace:
      return 'Remove whitespace inside the email address.';
    case EmailUnsupportedReason.MissingAtSign:
      return 'Include a single @ in the email address.';
    case EmailUnsupportedReason.MultipleAtSigns:
      return 'Use only one @ in the email address.';
    case EmailUnsupportedReason.InvalidLocalPart:
      return 'The part before @ is not supported.';
    case EmailUnsupportedReason.InvalidDomain:
      return 'The domain part of this email address is not supported.';
    case EmailUnsupportedReason.DomainLiteral:
      return 'Domain literal addresses are not supported.';
    default:
      return 'This email format is not supported.';
  }
}
